export const useOnSearch = ({ setSearch }: { setSearch: (search: string) => void }) => {
	return setSearch;
};
